const MEDIA_QUERY_MAP = {
	ns: "screen and (min-width: 768px)",
	m: "screen and (min-width: 30em) and (max-width: 60em)",
	l: "screen and (min-width: 60em)",
	ls: "screen and (orientation : landscape)",
};

export default (name: "ns" | "m" | "l" | "ls") => `@media only ${MEDIA_QUERY_MAP[name]}`;
